//about.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageShell from '../components/ui/PageShell';
import { Globals } from '../globalfunctions.js';

function About() {
  const navigate = useNavigate();
  useEffect(() => {
    if (Globals.LoginTime === null) navigate('/login');
  }, [navigate]);

  return (
    <PageShell>
      <h1>This is gonna change soon</h1>
    </PageShell>
  );
}

export default About;
